import React, { useEffect, useState } from 'react'
import { Field, change } from 'redux-form'
import { makeStyles } from '@material-ui/core/styles'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { FormHelperText } from '@material-ui/core'
import { useIntl } from 'react-intl'
import esLocale from 'react-phone-input-2/lang/es.json'
import frLocale from 'react-phone-input-2/lang/fr.json'
import ruLocale from 'react-phone-input-2/lang/ru.json'
import itLocale from 'react-phone-input-2/lang/it.json'
import deLocale from 'react-phone-input-2/lang/de.json'
import plLocale from 'react-phone-input-2/lang/pl.json'
import trLocale from 'react-phone-input-2/lang/tr.json'
import daLocale from './countriesLocalizations/da.json'
import nlLocale from './countriesLocalizations/nl.json'
import { fetchClientCountry } from '../redux/actions'
import { clientCountrySelector } from '../redux/selectors'
import { shallowEqual, useSelector } from 'react-redux'

const useASStyles = makeStyles(() => ({
	root: {
		'& .special-label': {
			top: 0,
			marginTop: '-1px',
			color: 'black',
			marginLeft: '-33px',
			fontSize: '17px',
			backgroundColor: 'transparent',
			transform: 'translate(12px, 8px) scale(0.85) !important',
			fontFamily: 'Source Sans Pro, sans-serif',
    		fontWeight: '400',
    		lineHeight: '1',
			padding: '0'
		}
	},
	inputError: {
		borderBottom: 'solid 2px red !important',
	}
}))

const styles = {
	input: {
		color: 'black',
		fontSize: '1rem',
		border: 'none',
		width: '100%',
		borderRadius: 0,
		paddingBottom: '9px',
		paddingTop: '27px',
		backgroundColor: 'rgba(0, 0, 0, 0.09)',
		'-webkit-text-fill-color': 'black',
    	'border-top-left-radius': '4px',
		'border-top-right-radius': '4px',
		'border-bottom': '1px solid rgba(0, 0, 0, 0.42)',
	},
	button: {
		paddingBottom: '10px',
		paddingTop: '27px'
	}
}

const localeMap = {
	en: "",
	es: esLocale,
	fr: frLocale,
	ru: ruLocale,
	it: itLocale,
	de: deLocale,
	da: daLocale,
	pl: plLocale,
	tr: trLocale,
	'en-GB': "",
	nl: nlLocale
}

const PhoneNumber = ({
	label,
	phoneField,
	phoneCountryCodeField,
	style,
	val,
	meta: { touched, error, initial, dispatch, form }
}) => {

	const classes = useASStyles()
	const intl = useIntl()
	const clientCountry = useSelector(clientCountrySelector, shallowEqual) 

	const [ value, setValue ] = useState(initial || null)
	const [ country, setCountry ] = useState('us')

	useEffect(() => {
		dispatch(fetchClientCountry())
	}, [])

	useEffect(() => {
		if(initial)
		{
			setValue(initial)
		}
	}, [initial])

    useEffect(() => {
        if (val) {
            setValue(val)
        }
	}, [val])

	useEffect(() => {
        if(clientCountry && !value){
			setCountry(clientCountry.toLowerCase())
		}
	}, [clientCountry])

	const handleChange = (phone, data, e, formattedValue) => {
		setValue(phone)
		dispatch(change(form, phoneField, phone))
		dispatch(change(form, phoneCountryCodeField, data.dialCode))
	}

	return (
		<div className="global-input-wrapper" style={{ ...style }}>
			<PhoneInput
				country={country}
				value={value}
				onChange={handleChange}
				enableSearch={true}
				inputStyle={styles.input}
				inputClass= {touched && error ? classes.inputError : null}
				buttonStyle={styles.button}
				containerClass={classes.root}
				specialLabel={label}
				placeholder=''
				localization={localeMap[intl.locale]}
				key={intl.locale}
			/>
			<FormHelperText
				style={{ color: '#f44336', padding: '0 0 10px 0', margin: '0', backgroundColor: 'white' }}
			>
				{touched && error}
			</FormHelperText>
		</div>
	)
}

const renderTextField = (field) => {
	return <PhoneNumber {...field} />
}

export const PhoneNumberField = ({
	label,
	name,
	inputLabelProps,
	inputProps,
	style,
	fullWidth,
	margin,
	variant,
	type,
	validators,
	suggestions,
	maxLength = 255,
	noMatchText = 'No Entries Found',
	...other
}) => {
	return (
		<Field
			name={name}
			component={renderTextField}
			label={label}
			inputLabelProps={inputLabelProps}
			inputProps={inputProps}
			maxLength={maxLength}
			style={style}
			fullWidth
			margin={margin}
			variant={variant}
			type={type}
			validate={validators}
			suggestions={suggestions}
			noMatchText={noMatchText}
			{...other}
		/>
	)
}
